<div class="hm-popular-category-main">
  <div class="container">
    <div class="hm-popular-category-child">
      <div class="hm-popular-category-title">
        <h2>{{ 'POPULAR_CATEGORIES.TITLE' | translate }}</h2>
      </div>

      <div class="hm-popular-category-items">
        <ul>
          <li>
            <a routerLink="/ads" [queryParams]="{ zone: 'københavn' }">{{
              'POPULAR_CATEGORIES.COPENHAGEN' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ zone: 'aarhus' }">{{
              'POPULAR_CATEGORIES.AARHUS' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ area: 'odense' }">{{
              'POPULAR_CATEGORIES.ODENSE' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ zone: 'aalborg' }">{{
              'POPULAR_CATEGORIES.AALBORG' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ area: 'sydsjælland' }">{{
              'POPULAR_CATEGORIES.SOUTH_ZEALAND' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ area: 'nordsjælland' }">{{
              'POPULAR_CATEGORIES.NORTH_ZEALAND' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ divisions: 'fyn' }">{{
              'POPULAR_CATEGORIES.FUNEN' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ area: 'midtsjælland' }">{{
              'POPULAR_CATEGORIES.MID_JUTLAND' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ area: 'sydjylland' }">{{
              'POPULAR_CATEGORIES.SOUTH_JUTLAND' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ area: 'vestjylland' }">{{
              'POPULAR_CATEGORIES.WEST_JUTLAND' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/ads" [queryParams]="{ area: 'nordjylland' }">{{
              'POPULAR_CATEGORIES.NORTH_JUTLAND' | translate
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
